(function () {
  class WinningsText extends PIXI.Container {
    constructor() {
      super();

      Reflex.registerEventHandler("ready", this.onReady.bind(this));
    }

    onReady = function () {
      this._container = resourceManager.get(
        this.name + ":winningsTextContainer"
      );
      this._mainText = resourceManager.get(
        this.name + ":winningsTextContainer:winningsText"
      );
      this._blackMask = resourceManager.get(
        this.name + ":winningsTextContainer:blackmask"
      );
      this._totalWinText = resourceManager.get(
        this.name + ":winningsTextContainer:winningsTextTotalWin"
      );
      this.blastAnim = resourceManager.get(
        this.name + ":winningsTextContainer:winBlastAnim"
      );
      this._winningsTextBar = resourceManager.get(
        this.name + ":winningsTextContainer:winningsTextBar"
      );

      this.blastAnim.gotoAndStop(0);

      this.winDiamondAnim = resourceManager.get(
        this.name + ":winningsTextContainer:winDiamondAnim"
      );
      this.winDiamondAnim.gotoAndStop(0);

      this.show(false);

      Reflex.deregisterEventHandler("ready", this.onReady.bind(this));
    };

    setText = function (value) {
      this._mainText.setText(gdk.formatCurrency(value));
    };

    show = function (show, value) {
      this._container.visible = show;

      if (value) this.setText(value);
    };

    setWinText = function (showWinText) {
      if (showWinText) {
        this._totalWinText.visible = false;
        this._winningsTextBar.visible = false;
        this._blackMask.alpha = 0.3;
      } else {
        this._totalWinText.visible = true;
        this._winningsTextBar.visible = true;
        this._blackMask.alpha = 0.3;
      }

      this.winDiamondAnim.visible = false;
      this.winDiamondAnim.gotoAndStop(0);
    };

    playDiamondAnimation = function () {
      this.winDiamondAnim.visible = true;
      this.winDiamondAnim.gotoAndPlay(0);
      this.blastAnim.gotoAndPlay(0);
    };

    setScale = function (scale) {
      this._container.scale.set(scale);
    };
  }

  let winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    "winningsText",
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
